






















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { VatsApi, Vat } from '../../api';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import moment from 'moment';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

@Component({
	components: {},
	props: {
		vatId: Number,
		vatEmptyDistance: Number,
		vatSizeString: [String, Number],
		vatOffset: Number,
		formula: String,
		height: Number,
	},
})
export default class ChartAdmin extends Vue {
	public moment = moment;
	public smallScreen = window.innerWidth;
	public visible = 'false';
	public graph;
	public vatId;
	public vatEmptyDistance;
	public vatSizeString;
	public vatOffset;
	public formula: string;
	public height: number;
	public chart: am4charts.XYChart;
	public offset = 0;
	public nDays = 2;
	public tempValueAxis;
	public form = {
		start: moment()
			.subtract(2, 'days')
			.locale('en-nz')
			.format('DD-MM-YYYY')
			.toString(),
		end: moment()
			.locale('en-nz')
			.format('DD-MM-YYYY')
			.toString(),
		shortcut: null,
	};

	@Watch('form.end', { immediate: true })
	public updateForm() {
		if (this.form.end !== null && this.form.start !== null) {
			this.updateRange(this.form.start, this.form.end);
			this.graphData();
		}
	}

	public dateNav(offset: number, direction: string) {
		if (this.form.start === '') {
			this.form.start = moment()
				.subtract(offset, 'days')
				.format('DD-MM-YYYY')
				.toString();
			this.form.end = moment()
				.format('DD-MM-YYYY')
				.toString();
		} else if (direction === 'prev') {
			this.form.end = moment(this.form.start, 'DD-MM-YYYY')
				.subtract(offset - 7, 'days')
				.format('DD-MM-YYYY')
				.toString();
			this.form.start = moment(this.form.start, 'DD-MM-YYYY')
				.subtract(offset, 'days')
				.format('DD-MM-YYYY')
				.toString();
		} else if (direction === 'next') {
			this.form.start = this.form.end;
			this.form.end = moment(this.form.end, 'DD-MM-YYYY')
				.add(offset, 'days')
				.format('DD-MM-YYYY')
				.toString();
		} else if (direction === 'start') {
			this.form.end = moment()
				.format('DD-MM-YYYY')
				.toString();
			this.form.start = moment(this.form.end, 'DD-MM-YYYY')
				.subtract(offset, 'days')
				.format('DD-MM-YYYY')
				.toString();
		}
	}
	// offset = current date - end date(offset is how far back it will look)
	// nDays = end date - start date (nDays is how many days back from the offset)
	public updateRange(start, end) {
		const a = moment(end, 'DD/MM/YYYY');
		const b = moment(start, 'DD/MM/YYYY');
		const c = moment(new Date(), 'DD/MM/YYYY').locale('en-nz');
		this.offset = c.diff(a, 'days');
		this.nDays = a.diff(b, 'days') + 1;
	}

	public mounted() {
		// this.graphData();
	}

	public beforeDestroy() {
		if (this.chart) {
			this.chart.dispose();
		}
	}

	public async graphData() {
		if (!this.vatId) {
			return;
		}
		try {
			const { data } = await new VatsApi().getVatGraphData(
				parseInt(this.vatId, 10),
				null,
				this.offset,
				this.nDays,
			);
			const emptyVolumeResponse = await this.axios.get(
				process.env.VUE_APP_API_URL.replace(/\/+$/, '') +
					'/vats/convert/convertDistance?distance=' +
					this.vatEmptyDistance +
					'&model=' +
					this.vatSizeString +
					'&offset=' +
					this.vatOffset +
					'&formula=' +
					this.formula +
					'&height=' +
					this.height,
			);
			const { emptyVolume } = emptyVolumeResponse.data;
			this.graph = data.data;
			await this.loadChart(emptyVolume);
		} catch (e) {
			console.log(e);
		} finally {
			// console.log('done');
		}
	}

	public destroyed() {
		window.removeEventListener('resize', this.myEventHandler);
	}
	public myEventHandler(e) {
		this.smallScreen = e.target.innerWidth;
	}
	public created() {
		window.addEventListener('resize', this.myEventHandler);
	}

	public async loadChart(emptyVolume: number) {
		// Themes
		// am4core.useTheme(am4themes_animated);
		if (this.chart) {
			await this.chart.dispose();
		}
		// Create chart instance
		this.chart = am4core.create('chartdiv' + this.vatId, am4charts.XYChart);

		// Increase contrast by taking evey second color
		this.chart.colors.step = 2;

		// this.chart = am4core.options.onlyShowOnViewport = true;

		// Create axes
		const dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
		dateAxis.renderer.minGridDistance = 50;
		dateAxis.baseInterval = { timeUnit: 'minute', count: 5 }; // timeUnit: "minute", count: 5
		// dateAxis.dateFormats.setKey("day", "HH:mm/MMM dd");
		dateAxis.tooltipDateFormat = '[bold]dd-MM-yy, h:mm:ss a[/]';
		// dateAxis.dateFormats.setKey('minute', 'h:mm a');
		dateAxis.renderer.grid.template.location = 0;
		this.chart.scrollbarX = new am4core.Scrollbar();
		// this.chart.scrollbarY = new am4core.Scrollbar();

		// Add legend and cursor
		this.chart.legend = new am4charts.Legend();
		this.chart.cursor = new am4charts.XYCursor();

		const valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
		this.createSeries(valueAxis, false, 'vatTemp', 'Temperature', true, 'rectangle', 'orange');
		this.createSeries(valueAxis, false, 'inletTemp', 'Inlet', true, 'triangle', 'red');

		const volumeAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
		this.createSeries(volumeAxis, true, 'volume', 'Volume', false, 'circle', '#aaa');

		const stirrerAxis = this.chart.yAxes.push(new am4charts.ValueAxis());

		let max = 200;
		for (const row in this.graph.stirrerValue) {
			if (this.graph.stirrerValue.hasOwnProperty(row)) {
				const value = this.graph.stirrerValue[row].value;
				max = value > max ? value : max;
			}
		}
		stirrerAxis.max = max + max * 0.1;
		this.createSeries(
			stirrerAxis,
			false,
			'stirrerValue',
			'Stirrer',
			false,
			'circle',
			'#505050',
			1.5,
		);

		const milkScoreAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
		milkScoreAxis.max = 4;
		this.createSeries(milkScoreAxis, false, 'milkScore', 'Score', false, 'circle', 'blue');

		// this.chart.cursor.behavior = 'zoomXY';
		this.chart.cursor.xAxis = dateAxis;

		dateAxis.dateFormatter = new am4core.DateFormatter();
		dateAxis.dateFormatter.dateFormat = 'MM-dd';

		dateAxis.renderer.axisFills.template.disabled = false;
		dateAxis.renderer.axisFills.template.fill = am4core.color('#F6861F');
		dateAxis.renderer.axisFills.template.fillOpacity = 0.2;

		let dateFlag = true;
		let dayTemp = 0;
		dateAxis.fillRule = (dataItem: any) => {
			if (dayTemp !== dataItem.date.getDay()) {
				dayTemp = dataItem.date.getDay();
				dateFlag = !dateFlag;
			}
			dataItem.axisFill.visible = dateFlag;
		};

		this.addHorizontalLine(volumeAxis, emptyVolume);
	}

	// Create series
	public createSeries(
		valueAxis: am4charts.ValueAxis,
		fillArea: boolean,
		field: string,
		name: string,
		opposite: boolean,
		shape: string,
		lineColor?: string,
		strokeWidth?: number,
	) {
		valueAxis.min = 0;

		if (field === 'vatTemp' || field === 'inletTemp') {
			valueAxis.max = 80;
		}

		const series = this.chart.series.push(new am4charts.LineSeries());
		series.dataFields.valueY = field;
		series.dataFields.dateX = 'date';
		series.strokeWidth = strokeWidth || 2;

		series.yAxis = valueAxis;

		series.name = name;
		series.tooltipText = '{name}: [bold]{valueY}[/]';
		series.connect = true;
		const skipped = 0;

		if (fillArea) {
			series.fillOpacity = fillArea ? 0.3 : 0;
			if (lineColor) {
				series.fill = lineColor;
			}
		}

		if (lineColor) {
			series.stroke = am4core.color(lineColor);
			series.fill = lineColor;
		}

		const prevPoint = null;
		let prevAdded = null;
		let prevSkipped = null;

		const chartData = [];
		for (const row in this.graph[field]) {
			if (this.graph[field].hasOwnProperty(row)) {
				const newDate = new Date(this.graph[field][row].date);
				let label = '';
				let size = 0;
				let fill = am4core.color('#fff');
				if (this.graph[field][row].label) {
					label = this.graph[field][row].label;
					size = this.graph[field][row].size;
					if (
						label === 'chiller' ||
						label === 'too warm' ||
						label === 'too cold' ||
						label === 'overfill' ||
						label === 'stirrer alert' ||
						label === 'reboot'
					) {
						fill = null;
					}
				}

				/*to opitimse graphs skip consecutive values that are the same
          when skipping hold last datapoint that was skipped and add before
          the value changes to accuratly reflect length of time the values were
          the same
        */
				const value = this.graph[field][row].value;
				const dataPoint = {
					date: newDate,
					label,
					size,
					[field]: value,
					fill,
				};

				if (prevAdded === null || prevAdded[field] !== dataPoint[field] || dataPoint.label.length) {
					if (prevSkipped !== null) {
						chartData.push(prevSkipped);
					}
					chartData.push(dataPoint);
					prevSkipped = null;
					prevAdded = dataPoint;
				} else {
					prevSkipped = dataPoint;
				}
			}
		}

		// if last item was skipped add to to graph
		if (prevSkipped !== null) {
			chartData.push(prevSkipped);
		}

		series.data = chartData;

		const interfaceColors = new am4core.InterfaceColorSet();

		// labels
		if (
			field === 'volume' ||
			field === 'vatTemp' ||
			field === 'inletTemp' ||
			field === 'stirrerValue' ||
			field === 'milkScore'
		) {
			const bullet = series.bullets.push(new am4charts.CircleBullet());
			// bullet.circle.fill = am4core.color('#fff');
			bullet.circle.strokeWidth = 2;
			bullet.circle.propertyFields.radius = 'size';
			bullet.circle.propertyFields.fill = 'fill';

			const seriesLabel = series.bullets.push(new am4charts.LabelBullet());
			seriesLabel.label.text = '{label}';
			seriesLabel.label.horizontalCenter = 'left';
			seriesLabel.label.fontSize = 8;
			seriesLabel.label.dx = 5;
		}
		valueAxis.renderer.line.strokeOpacity = 1;
		valueAxis.renderer.line.strokeWidth = 2;
		valueAxis.renderer.line.stroke = series.stroke;
		valueAxis.renderer.labels.template.fill = series.stroke;
		valueAxis.renderer.opposite = !(field === 'volume' || field === 'milkScore');

		valueAxis.renderer.grid.template.disabled = true;

		this.setValueAxis(valueAxis, field);
	}

	private setValueAxis(valueAxis, field) {
		switch (field) {
			case 'milkScore':
				valueAxis.strictMinMax = true;
				valueAxis.max =
					1.1 *
					Math.max(
						...Object.keys(this.graph[field]).map(o => {
							return this.graph[field][o].value;
						}),
						4,
					);

				valueAxis.min = 0;
				break;
		}
	}

	private addHorizontalLine(
		valueAxis: am4charts.ValueAxis<am4charts.AxisRenderer>,
		yValue: number,
		colorHexCode: string = '#e00000',
	): void {
		const range = valueAxis.axisRanges.create();
		range.value = yValue;
		range.grid.stroke = am4core.color(colorHexCode);
		range.grid.strokeWidth = 2;
		range.grid.strokeOpacity = 1;
		range.grid.strokeDasharray = '0 3 30';
	}
}
